import Vue from 'vue'
import Vuex from 'vuex'
import Chat from "./modules/Chat/Chat";
import Shop from "./modules/Shop";
import Recon from "./modules/Recon";
import Invoice from "./modules/Invoice";
import Address from './modules/Address';
import User from './modules/User';
import HomeNotice from "./modules/HomeNotice";
import Order from "./modules/Order";
import enquiryRecord from "./modules/enquiryRecord";
import orderRecord from "./modules/orderRecord";
import buyerBackList from "./modules/buyerBackList";
import dealerBackList from "./modules/dealerBackList";
import Quote from "./modules/Quote";
import UnReadMessage from './modules/UnReadMessage';
import partTypeStore from './modules/partTypeStore';
import { getAllRoutesMeta } from '../router/index'
//挂载Vuex
Vue.use(Vuex)
function checkTitleForRoutes(componentName=''){
  const result = getAllRoutesMeta()
  const filterResult = result.filter(i=>i.name===componentName)
  if(!filterResult && !filterResult.length && !filterResult[0].meta.title) return ''
  return filterResult[0].meta.title
}
function checkTitle(newTab='') {
  let title = "";
  if (newTab == "index") {
    title = "首页";
  }else if(newTab==='yaInsreportsjd'){
    title='周期统计(询) ';
  }else if(newTab==='insreportsjdDaily'){
    title='单日统计(询) ';
  } else if(newTab==='pjscheck'){
    title='配件管理';
  } else if(newTab==='pjsupload'){
    title='上传配件';
  }else if(newTab ==='report'){
    title='统计';
  } else if (newTab == "queryPrice") {
    //报价
    title = "报价入口";
  } else if (newTab == "queryPriceList") {
    title = "报价列表";
  } else if (newTab == "quoteDetail") {
    title = "被选中";
  } else if (newTab == "shopindex") {
    title = "店铺";
  } else if (newTab == "epcindexv2") {
    //EPC
    title = "EPC查询";
  } else if (newTab == "bxgsSale") {
    //我的订单
    title = "订单信息";
  } else if (newTab == "OrderListseller") {
    title = "售出订单";
  } else if (newTab == "OrderList") {
    title = "我的下单";
  } else if (newTab == "queryEnquiryInfo") {
    title = "录入订单";
  } else if (newTab == "cjqueryEnquiryInfo") {
    //创建订单
    title = "创建订单";
  } else if (newTab == "cjOrderList") {
    title = "订单列表";
  } else if (newTab == "unsalableIndex") {
    //滞销外销
    title = "滞销单列表";
  } else if (newTab == "exportBidding") {
    title = "4S外销配件";
  } else if (newTab == "unsalableInsert") {
    title = "发布滞销单";
  } else if (newTab == "unsalableBuyListFlag") {
    title = "售出列表";
  } else if (newTab == "unsalableBuyList") {
    title = "下单列表";
  } else if (newTab == "fourSinsert") {
    //滞销库存
    title = "发布滞销库存";
  } else if (newTab == "fourSindexFlag") {
    title = "滞销库存列表";
  } else if (newTab == "fourSbuyListFlag") {
    title = "售出列表";
  } else if (newTab == "fourSbuyList") {
    title = "下单列表";
  } else if (newTab == "fourSexportBidding") {
    //配件外销
    title = "外销列表";
  } else if (newTab == "fourSaddBidding") {
    title = "发布外销包";
  } else if (newTab == "maintainIndex") {
    //保养
    title = "保养查询";
  } else if (newTab == "shopindex") {
    //店铺
    title = "我的店铺";
  } else if (newTab == "myshoplist") {
    title = "我的店铺商品";
  } else if (newTab == "shopmanager") {
    title = "管理员/员工";
  } else if (newTab == "shopupd") {
    title = "上传商品";
  } else if (newTab == "myshopvip") {
    title = "我的会员";
  } else if (newTab == "myVisit") {
    title = "我的店铺访客";
  } else if (newTab == "aboutMeInfo") {
    title = "配件询价单";
  } else if (newTab == "shopOrder") {
    title = "我的店铺订单";
  } else if (newTab == "shopdetail") {
    title = "商品详情";
  } else if (newTab == "buyvip") {
    title = "购买会员";
  } else if (newTab == "jnmbPrice") {
    //秒报询价
    title = "秒报";
  } else if (newTab == "jnxjPrice") {
    title = "询价";
  } else if (newTab == "queryenquiryinfolist") {
    title = "询价列表";
  } else if (newTab == "querypriceInfolist") {
    title = "列表";
  } else if (newTab == "queryenquiryinfolisteState" || newTab==='xlcInquiryDetailTemporaryStorage') {
    title = "暂存";
  } else if (newTab == "doUserInfo") {
    //设置
    title = "个人信息";
  } else if (newTab == "mimaedit") {
    title = "修改密码";
  } else if (newTab == "scopeedit") {
    title = "经营范围";
  } else if (newTab == "queryuserdistrict") {
    title = "报价区域";
  } else if (newTab == "Relation") {
    title = "合作关系";
  } else if (newTab == "chatlist") {
    title = "聊天记录";
  } else if (newTab == "Feebalance") {
    title = "查询充值";
  } else if (newTab == "insreportsjd") {
    //报表统计
    title = "周期统计";
  } else if (newTab == "insreport") {
    title = "单日统计";
  } else if (newTab == "insdirectsupplysjd") {
    title = "直供统计";
  } else if (newTab == "inquiryList") {
    title = "询价清单";
  } else if (newTab == "EPCQueryList") {
    title = "EPC查询清单";
  } else if (newTab == "EPCQueryPartList") {
    title = "EPC零件清单";
  } else if (newTab == "cooperate") {
    //合作关系
    title = "配件商合作";
  } else if (newTab == "damagecar") {
    title = "竞拍商合作";
  } else if (newTab == "mb" || newTab==='xlcmbDetail') {
    title = "秒报单详情";
  } else if (newTab == "getInfoByOEcode") {
    title = "OE码查询";
  }
  else if (newTab == "jnquotedetail") {
    title = "报价详情";
  }
  else if(newTab==='xlcmbDetailTemporaryStorage'){
    title='秒报暂存';
  }else if(newTab==='factoryShopIndex') title='商城';
  else if(newTab==='factoryShopBuyCar') title='购物车';
  else if(newTab==='factoryOrder') title='下单';
  else if(newTab==='factoryOrderDetail') title='下单详情';
  else if(newTab==='factoryNoticeList') title='公告';
  var arr = [
    {
      title: '平台服务费',
      item: ['sale'],
    },
    {
      title:'询价单详情',
      item:['xlcInquiryDetail','createPictureForm','createForm']
    },
    {
      title:'收货地址',
      item:['ShippingAddress']
    },
    {
      title: '发票管理',
      item:['InvoiceManage'],
    },
    {
      title:'申请发票列表',
      item:['applyInvoiceList']
    },
    {
      title:'轮胎搜索',
      item:['tiresHome']
    },
    {
      title:'商品详情',
      item:['ProductDetail']
    },
    {
      title:'待下单(修理厂)',
      item:['queryEnquiryInfoListxlc']
    },
    {
      title: '首页公告',
      item: ['HomeNotice']
    },
    {
      title:'询价暂存',
      item:['createFormTemporaryStorage']
    },
    {
      title:'复勘列表',
      item:['reconList']
    },
    {
      title:'复勘新增',
      item:['reconAdd']
    },
    {
      title:"复勘详情",
      item:['reconDetail']
    },
    {
      title:'复勘鉴定',
      item:['reconAppraisal']
    },
    {
      title:'供货反馈',
      item:['apsCreateDirectSupplyOrder']
    },
    {
      title:'询价单录入',
      item: ['enquiryRecord']
    },
    {
      title:'录入暂存',
      item: ['enquiryRecordStaging']
    },
    {
      title:'录入暂存详情',
      item: ['enquiryRecordStagingDetail'],
    },
    {
      title:'通知列表',
      item:['notificationList']
    },
    {
      title: '录入订单暂存',
      item: ['orderStaging'],
    },
    {
      title: '订单暂存详情',
      item: ['orderStagingDetail'],
    },
    {
      title: '残值车列表',
      item: ['salvageCarList'],
    },
    {
      title: '残值车发布',
      item: ['salvageCarInsert'],
    },
    {
      title: '残值车详情',
      item: ['salvageCarDetail'],
    },
    {
      title: '中标列表',
      item: ['successfulBidderList'],
    },
  ];
  const f = arr.find(i=>i.item.includes(newTab));
  if(title || f) return title?title:f?f.title:'';
  const resultForRoutes = checkTitleForRoutes(newTab)
  if(resultForRoutes) return resultForRoutes
  return ''
}
//创建VueX对象
const store = new Vuex.Store({
    state: {
        //存放的键值对就是所要管理的状态
        // name:'helloVueX'
        logo: '',
        mainColor: '',
        secondColor: '',
        openedTab: ['index'],
        activeTab: 'index',
        companyName:'',
        editableTabs:[
            {
                title:'首页',
                name:'index'
            }
        ],/*渲染tab栏*/
        latitude: '', // 当前位置纬度
        longitude: '', // 当前位置经度
        cartList: {}, // 加入购物车的商品列表
        shopDetail: null, //商家详情信息
        shopid: null,//商铺id
        remarkText: null,//可选备注内容
        inputText: '',//输入备注内容
        invoice: false,//开发票
        newAddress: [], //确认订单页新的地址
        searchAddress: null,//搜索并选择的地址
        geohash: '31.22299,121.36025',//地址geohash值
        choosedAddress: null,//选择地址
        addressIndex: null,//选择地址的索引值
        needValidation: null,//确认订单时是否需要验证
        cartId: null, //购物车id
        sig: null,//购物车sig
        orderParam: null,//订单的参数
        orderMessage: null, //订单返回的信息
        orderDetail: null, //订单详情
        imgPath:null,//头像地址
        removeAddress:[],//移除地址
        addAddress:'',		//新增地址
        question: null,//问题详情
        cartPrice: null, //会员卡价格
      websocketConnectStatus: true,
    },
    mutations: {
      changeState(state,obj){
        Object.entries(obj).forEach(item=>{
          Vue.set(state, item[0], item[1]);
        })
      },
        // ...mumations,
        //es6语法，等同edit:funcion(){...}
        edit(state, obj) {
            // console.log('store obj=' + JSON.stringify(obj));
            // state.name = 'jack'
            // state.log=obj.logo;
            // state.mainColor = obj.mainColor;
            // state.secondColor = obj.secondColor;
            Vue.set(this.state, 'logo', obj.logo);
            // this.$set(state, 0, obj.log);
            Vue.set(this.state, 'mainColor', obj.mainColor);
            Vue.set(this.state, 'secondColor', obj.secondColor);
            Vue.set(this.state, 'companyName', obj.companyName);
        },
        addTabQuery(state,{componentName='',query={}}){
            state.openedTab.push(componentName);
            state.activeTab=componentName;
            state.editableTabs.push({
                title:checkTitle(componentName),
                name:componentName,
                query
            });
        },
        addTab(state, componentName) {
            openVueLoading();
            if(typeof componentName==="string"){
                state.openedTab.push(componentName);
                state.editableTabs.push({
                    title:checkTitle(componentName),
                    name:componentName
                });
                state.activeTab=componentName;
            }
            else if(typeof componentName==="object"){
                const push={};
                if(componentName.componentName){
                    push.name=componentName.componentName;
                    push.title=checkTitle(componentName.componentName);
                }
                if(componentName.query)push.query=componentName.query;
                if(componentName.params)push.params=componentName.params;
                state.openedTab.push(componentName.componentName);
                state.editableTabs.push(push);
                state.activeTab=componentName.componentName;
            }

        },
        changeTabQuery(state,{componentName='',query={}}){
            state.activeTab = componentName;
            state.editableTabs.find(i=>i.name===componentName).query=query;
        },
        changeTab(state, componentName) {
            if(typeof componentName==="string") state.activeTab = componentName;
            else if(typeof componentName==="object"){
                if(componentName.refresh) {
                    const c = {...componentName};
                    state.openedTab.includes(componentName.componentName) && this.commit('deductTab',componentName.componentName);
                    setTimeout(() => this.commit('addTab',c));
                }
                else{
                    const active = state.editableTabs.findIndex(i=>i.name===componentName.componentName);
                    if(active>=0){
                        const c = {...componentName};
                        const activeTab = {
                            name:c.componentName,
                            title:checkTitle(c.componentName),
                        };
                        if(c.query) activeTab.query=c.query;
                        if(c.params) activeTab.params=c.params;
                        state.editableTabs[active] = activeTab;
                        state.activeTab = componentName.componentName;
                    }
                    else this.commit('addTab',componentName);
                }
            }
        },
        deductTab(state, componentName) {
            let index = state.openedTab.indexOf(componentName);
            if(index<0) return;
            state.openedTab.splice(index, 1);
            state.editableTabs.splice(index,1);
            if(state.activeTab===componentName){
                state.activeTab = state.openedTab[index]?state.openedTab[index]:state.openedTab[state.openedTab.length-1];
            }
            if(componentName==='queryenquiryinfolist'){
                this.commit('initSearchContentMutation');
            }
            else if(componentName==='queryPriceList'){
                this.commit('initQuoteSearchContentMutation');
            }
            else if(componentName==='jnquotedetail'){
                this.commit('updateQuoteDetailDataMutation');
            }
            else if(componentName==='createForm'){
                this.commit('enquiryPriceDetailMutation');
            }
        }

    },
    getters:{
      getAppInfo: () => {
        return {
          appName: '鑫卡盟',
          ICP: '沪ICP备2024042089号-1',
        }
      },
      getIsNotProduction: () => process.env.NODE_ENV!=='production',
      getEnvironment: () => process.env.NODE_ENV,
        getWebInfo:state => {
          return {
              logo:state.logo
          }
        },
        getResturantName: (state) => {
            return state.resturantName;
        },
        getJwt: (state) => {
            return state.jwt;
        },
        getShowName:(state) => {
            return state.showName;
        },
        getOptions:(state) => {
            return state.options;
        },
        getRole:(state) =>{
            return state.role;
        }
    },
    modules:{
      UnReadMessage,
      Quote,
      Chat,
      Shop,
      Invoice,
      Address,
      User,
      HomeNotice,
      Order,
      Recon,
      enquiryRecord,
      orderRecord,
      buyerBackList,
      dealerBackList,
      partTypeStore,
    },
});

export default store;
